import { HttpClient } from '@angular/common/http';
import { Injector } from '@angular/core';
import { IBlockchain } from '@services/api/blockchain';
import { BaseContractFactory } from '@services/currencies-factory/contract-factory-base';
import { EVMErc20ContractFactory } from '@services/currencies-factory/evm-erc20-contract-factory.service';
import { NetworksService } from '@services/networks/networks.service';
import { StorageService } from '@services/storage/storage.service';
import {NFT_SPECIFICATION} from '@services/nft-observer/nft-observer.service';

export interface INftObserver
{
    loadAccountNFTTokens(_walletAddress: string);
}

export enum TokenUrlType
{
    base64 = 'base64',
    ipfs = 'ipfs',
    api = 'api'
}

export interface INftByBlockchain
{
    blockchain: IBlockchain;
    walletNFT: IWalletNft;
    amountNFT: number;
    collapse: boolean;
    blockNumber?: string | number;
    lastLogs?: { blockNumber: string, hash: string }[];
    blockNumberErc1155?: string | number;
    lastLogsErc1155?: { blockNumber: string, hash: string }[];
    // blockNumber?: { erc721Block: any, erc1155Block: any } ;
    // lastLogs?:  { erc721Logs: { blockNumber: string, hash: string; }[], erc1155Logs: { blockNumber: string, hash: string; }[] }
}

export interface IWalletNft
{
    [ contractAddress: string ]: IContractNft,
}

export interface IContractNft
{
    amount: number;
    collapse: boolean;
    isLoadNFT: boolean;
    name: string;
    symbol: string;
    tokenId: number[];
    tokenIdAll?: { [ tokenId: string ]: number };
    tokenHash: { [ tokenId: string ]: string };
    nftData?: IDataNft[];
    isErc1155: boolean;
}

export interface IDataNft
{
    contractAddress: string,
    tokenId: string | number,
    tokenType: string
    data?: {
        name: string,
        image: string,
        description: string,
    },
    result?: number,
    tokenUri?: string,
}

export abstract class NftObserver implements INftObserver
{
    protected contractFactory: BaseContractFactory;
    protected networksService: NetworksService;
    protected http: HttpClient;
    protected indexDBService: StorageService;
    protected walletAddress: string;

    constructor(protected injector: Injector, _walletAddress: string)
    {
        this.walletAddress = _walletAddress;
        this.contractFactory = this.injector.get(EVMErc20ContractFactory);
        this.networksService = this.injector.get(NetworksService);
        this.indexDBService = this.injector.get(StorageService);
        this.http = this.injector.get(HttpClient);
    }

    public abstract loadAccountNFTTokens(_walletAddress: string);

    public findAccountNFT(_logs: any[], _walletAddress: string, _nftFromCache: IWalletNft = {}): IWalletNft
    {
        let countNft: IWalletNft = _nftFromCache;

        for (let log of _logs)
        {
            if (countNft[ log.contractAddress ] !== undefined)
            {
                if (log.to.toLowerCase() == log.from.toLowerCase())
                {
                    countNft[ log.contractAddress ].tokenHash[ log.tokenID.toString() ] = log.hash;
                    continue;
                }
                else if (log.from.toLowerCase() == _walletAddress.toLowerCase())
                {
                    if (log.type !== NFT_SPECIFICATION.erc1155)
                    {
                        countNft[ log.contractAddress ].amount -= 1;
                        const delIndx = countNft[ log.contractAddress ].tokenId.findIndex(v => v === log.tokenID);
                        countNft[ log.contractAddress ].tokenId.splice(delIndx, 1);
                        delete countNft[ log.contractAddress ].tokenHash[ log.tokenID.toString() ];
                    }
                    else if (countNft[ log.contractAddress ]?.tokenIdAll?.[log.tokenID] >= 0)
                    {
                        const radix = 10;
                        const tokenValue = parseInt(log.tokenValue, radix);
                        countNft[ log.contractAddress ].tokenIdAll[log.tokenID] -= tokenValue;
                        countNft[ log.contractAddress ].amount -= tokenValue;

                        if (countNft[ log.contractAddress ]?.tokenIdAll?.[log.tokenID] < 1)
                        {
                            const delIndx = countNft[ log.contractAddress ].tokenId.findIndex(v => v === log.tokenID);
                            countNft[ log.contractAddress ].tokenId.splice(delIndx, 1);
                            delete countNft[ log.contractAddress ].tokenHash[ log.tokenID.toString() ];
                        }
                    }
                    else
                    {
                        countNft[ log.contractAddress ].tokenIdAll = {};
                    }

                    // if (countNft[ log.contractAddress ]?.tokenIdAll?.[log.tokenID] < 1)
                    // {
                    //     console.log("countNft[ log.contractAddress ]?.tokenIdAll?.[log.tokenID] < 1");
                    //     console.log(countNft[ log.contractAddress ]?.tokenIdAll?.[log.tokenID]);
                        
                    // }
                    // if (countNft[ log.contractAddress ]?.tokenIdAll)
                    // if (!countNft[ log.contractAddress ]?.tokenIdAll) {
                    //     countNft[ log.contractAddress ].tokenIdAll = {};
                    // }

                    // const tokenIndex = countNft[ log.contractAddress ].tokenIdAll.findIndex(v => v === log.tokenID);
                    // if (tokenIndex !== -1) {
                    //     countNft[ log.contractAddress ].tokenIdAll.splice(tokenIndex, 1);
                    // }

                    // if (log.type === NFT_SPECIFICATION.erc1155) {
                    //     const radix = 10;
                    //     const tokenValue = parseInt(log.tokenValue, radix);
                    //     new Array(tokenValue).fill(0).forEach(() => countNft[ log.contractAddress ].tokenIdAll.push(log.tokenID));
                    // }
                }
                else if (log.to.toLowerCase() == _walletAddress.toLowerCase())
                {
                    if (!countNft[ log.contractAddress ].tokenId.includes(log.tokenID)) {
                        countNft[ log.contractAddress ].amount += 1;
                        countNft[ log.contractAddress ].tokenId.push(log.tokenID);
                        countNft[ log.contractAddress ].tokenHash[ log.tokenID.toString() ] = log.hash;
                    }

                    if (log.type === NFT_SPECIFICATION.erc1155)
                    {
                        if (!countNft[ log.contractAddress ]?.tokenIdAll) {
                            countNft[ log.contractAddress ].tokenIdAll = {};
                        }

                        if (countNft[ log.contractAddress ].tokenIdAll?.[log.tokenID] == undefined)
                        {
                            countNft[ log.contractAddress ].tokenIdAll[log.tokenID] = 0
                        }
                        else
                        {
                            countNft[ log.contractAddress ].amount += 1;
                        }

                        const radix = 10;
                        const tokenValue = parseInt(log.tokenValue, radix);
                        countNft[ log.contractAddress ].tokenIdAll[log.tokenID] += tokenValue;
                        countNft[ log.contractAddress ].amount += tokenValue - 1;
                        // new Array(tokenValue).fill(0).forEach(() => countNft[ log.contractAddress ].tokenIdAll.push(log.tokenID));
                    }
                }
                else
                {
                    console.log('Fake transaction!');
                    console.log(log);
                }
            }
            else
            {
                if (log.to.toLowerCase() == _walletAddress.toLowerCase())
                {
                    const tokenIdAll = {};
                    let erc1155Value = 0;
                    if (log.type === NFT_SPECIFICATION.erc1155) {
                        const radix = 10;
                        const tokenValue = parseInt(log.tokenValue, radix);
                        tokenIdAll[log.tokenID] = tokenValue;
                        erc1155Value = tokenValue - 1;
                        // new Array(tokenValue).fill(0).forEach(() => tokenIdAll.push(log.tokenID));
                    }

                    countNft[ log.contractAddress ] = {
                        amount: 1 + erc1155Value,
                        collapse: true,
                        isLoadNFT: false,
                        name: log.tokenName,
                        symbol: log.tokenSymbol,
                        tokenId: [ log.tokenID ],
                        tokenHash: { [ log.tokenID.toString() ]: log.hash },
                        isErc1155: log.type === NFT_SPECIFICATION.erc1155,
                        tokenIdAll,
                    };
                }
                else
                {
                    console.log('Fake transaction! Before getting nft!');
                    console.log(log);
                }
            }
        }

        for (let contractAddress in countNft)
        {
            if (countNft[ contractAddress ].amount < 1)
            {
                delete countNft[ contractAddress ];
            }
        }
        console.log(countNft);
        return countNft;
    }

    public getUniqueLogs(_logsFirst: any[], _logs: any[], _blockNumber: number)
    {
        const findByBlock = _logsFirst.filter(v => v.blockNumber == _blockNumber);

        const result: any[] = [];

        for (const log of _logs)
        {
            if (log.blockNumber != _blockNumber)
            {
                result.push(log);
                continue;
            }

            const index = findByBlock.findIndex((item) =>
            {
                return item.hash == log.hash;
            });

            if (index == -1)
            {
                result.push(log);
            }
        }

        return [ ..._logsFirst, ...result ];
    }

    public getTypeUrl(_url: string)
    {
        let urlType;

        if (_url.startsWith('data:application/json;base64,'))
        {
            urlType = TokenUrlType.base64;
        }
        else if (_url.startsWith('ipfs://'))
        {
            urlType = TokenUrlType.ipfs;
        }

        return urlType;
    }

    public checkResponse(_response: any)
    {
        let respResult = {};

        if (_response.status !== 200)
        {
            respResult[ 'result' ] = -1;
        }
        else
        {
            respResult[ 'data' ] = _response;
        }

        return respResult;
    }

    public choiceIpfs(): string
    {
        const IPFS_PROVIDER_HOST = [
            'https://ipfs.eth.aragon.network/ipfs/',
            'https://storry.tv/ipfs/',
            'https://cloudflare-ipfs.com/ipfs/',
            // 'https://ipfs-gateway.cloud/ipfs/',
            // 'https://ipfs.io/ipfs/'
        ];

        const randomNumber = Math.floor(Math.random() * IPFS_PROVIDER_HOST.length);

        return IPFS_PROVIDER_HOST[ randomNumber ];
    }

    public prepareImageIpfs(data: any)
    {
        const SCHEME_IPFS = 'ipfs://';
        const httpIpfsRegex = new RegExp(/(.*)\/ipfs\/(.*)/);
        const uri = data?.image;

        if (uri)
        {
            let subImgUri;
            let imgUri = uri;
    
            if (imgUri.startsWith(SCHEME_IPFS))
            {
                subImgUri = imgUri.substring(SCHEME_IPFS.length);
                imgUri = this.choiceIpfs() + subImgUri;
            }
            else if (httpIpfsRegex.test(uri))
            {
                subImgUri = imgUri.match(httpIpfsRegex)[ 2 ];
                imgUri = this.choiceIpfs() + subImgUri;
            }

            data.image = imgUri;
        }

        return;
    }
}
